import { Box, IconButton, SvgIcon } from '@mui/material';
import SearchIcon from 'assets/icons/search.svg';
import SearchField from 'components/controls/SearchField';
import { func, string } from 'prop-types';
import React, { useState } from 'react';

const Search = ({ value = '', onChange }) => {
  const [isVisible, setVisible] = useState(false);

  const toggleVisible = () => {
    setVisible(oldValue => !oldValue);
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {isVisible && <SearchField onChange={onChange} value={value} />}

      <IconButton sx={{ ml: '5px' }} onClick={toggleVisible} size="large">
        <SvgIcon color="primary" sx={{ fontSize: 16 }}>
          <SearchIcon />
        </SvgIcon>
      </IconButton>
    </Box>
  );
};

Search.propTypes = {
  value: string,
  onChange: func.isRequired,
};

export default Search;
